export const NOTIFICATION_POINTS_TYPES = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};
export const REQUIRED_PHONE_LENGTH = 10;
